var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIeliminar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.44 0C73.5917 0 85.4705 3.60339 95.5742 10.3545C105.678 17.1056 113.553 26.7012 118.203 37.9279C122.853 49.1546 124.07 61.5082 121.699 73.4263C119.329 85.3445 113.477 96.2921 104.885 104.885C96.2921 113.477 85.3445 119.329 73.4263 121.699C61.5082 124.07 49.1546 122.853 37.9279 118.203C26.7012 113.553 17.1056 105.678 10.3545 95.5742C3.60339 85.4705 0 73.5917 0 61.44C0 45.1451 6.47312 29.5176 17.9954 17.9954C29.5176 6.47312 45.1451 0 61.44 0ZM74.58 36.8C76.32 35.03 77.41 33.62 79.58 35.8L86.58 42.93C88.87 45.19 88.75 46.51 86.58 48.62L73.33 61.83L86.08 74.58C87.85 76.32 89.26 77.41 87.08 79.58L79.95 86.58C77.69 88.87 76.37 88.75 74.27 86.58L61.44 73.72L48.63 86.53C46.53 88.68 45.21 88.8 42.95 86.53L35.82 79.53C33.62 77.38 35.03 76.29 36.82 74.53L49.55 61.83L36.35 48.64C34.2 46.53 34.08 45.21 36.35 42.95L43.35 35.82C45.5 33.62 46.59 35.03 48.35 36.82L61.44 49.94L74.58 36.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIeliminar);
export default __webpack_public_path__ + "static/media/ieliminar.9a72bd04c4d0866bc8695bd457a45c20.svg";
export { ForwardRef as ReactComponent };